import "./include/App.css";
import "./include/darkforest.woff2";
import { useState, useEffect, useCallback } from "react";

import { MainContent } from "./elements/MainContent";
import { FloatingButtons } from "./elements/FloatingButtons";
import { ConfirmModal } from "./elements/ConfirmModal";
import * as ServerInterface from "./ServerInterface";

export const States = {
  SpinTheWheel: "SpinTheWheel",
  ChooseSpinner: "ChooseSpinner",
  EditSpinner: "EditSpinner",
  AddSpinner: "AddSpinner",
  Login: "Login",
};

function App() {
  const [state, setState] = useState(States.ChooseSpinner);
  const [spinnerList, setSpinnerList] = useState([]);
  const [spinnerId, setSpinnerId] = useState(undefined);
  const [spinnerName, setSpinnerName] = useState(undefined);
  const [spinnerEntries, setSpinnerEntries] = useState([]);
  const [hideCheckedEntries, setHideCheckedEntries] = useState(false);

  const [askToConfirm, setAskToConfirm] = useState(false);
  const [deleteName, setDeleteName] = useState(undefined);
  const [deleteId, setDeleteId] = useState(undefined);

  const syncWithServer = useCallback(async () => {
    setSpinnerList(await ServerInterface.listSpinners());
    if (spinnerId) {
      setSpinnerEntries(await ServerInterface.listEntries(spinnerId));
    }
  }, [spinnerId]);

  useEffect(() => {
    syncWithServer();
  }, [spinnerId, syncWithServer]);

  function chooseSpinner(spinnerId, spinnerName) {
    setSpinnerId(spinnerId);
    setSpinnerName(spinnerName);
    setState(States.SpinTheWheel);
  }

  async function createSpinner(spinnerName, spinnerEntries) {
    const [success, newSpinnerId] = await ServerInterface.addSpinner(
      spinnerName,
      spinnerEntries.map((text) => ({ entry: text, visible: true })),
    );

    if (success) {
      setSpinnerId(newSpinnerId);
      setSpinnerName(spinnerName);
      setState(States.SpinTheWheel);
    }
  }

  async function deleteSpinner(spinnerIdToDelete, spinnerNameToDelete) {
    setDeleteName(spinnerNameToDelete);
    setDeleteId(spinnerIdToDelete);
    setAskToConfirm(true);
  }

  async function confirmDeleteSpinner() {
    const success = await ServerInterface.deleteSpinner(deleteId);
    if (success) {
      if (`${deleteId}` === `${spinnerId}`) {
        setSpinnerId(undefined);
        setSpinnerName(undefined);
      } else {
        syncWithServer();
      }
    }

    setDeleteName(undefined);
    setDeleteId(undefined);
    setAskToConfirm(false);
  }

  async function cancelDeleteSpinner() {
    setDeleteName(undefined);
    setDeleteId(undefined);
    setAskToConfirm(false);
  }

  async function addNewEntry(text) {
    ServerInterface.addEntry(spinnerId, text, true).then(syncWithServer);
  }

  async function deleteEntry(entryId) {
    ServerInterface.deleteEntry(entryId).then(syncWithServer);
  }

  function toggleEntryVisible(entryId) {
    ServerInterface.toggleVisible(entryId).then(syncWithServer);
  }

  // for future use
  function login(username, password) {
    console.log("LOGGING IN:", username, password);
  }

  return (
    <div className="App">
      <Title state={state} spinnerName={spinnerName} />
      <div className="content">
        <MainContent
          state={state}
          setState={setState}
          spinnerList={spinnerList}
          chooseSpinner={chooseSpinner}
          deleteSpinner={deleteSpinner}
          createSpinner={createSpinner}
          spinnerEntries={spinnerEntries}
          addNewEntry={addNewEntry}
          deleteEntry={deleteEntry}
          toggleEntryVisible={toggleEntryVisible}
          hideCheckedEntries={hideCheckedEntries}
          login={login}
        />
        <FloatingButtons
          state={state}
          spinnerId={spinnerId}
          setState={setState}
          hideCheckedEntries={hideCheckedEntries}
          setHideCheckedEntries={setHideCheckedEntries}
        />
        {askToConfirm ? (
          <ConfirmModal
            spinnerName={deleteName}
            onConfirm={confirmDeleteSpinner}
            onCancel={cancelDeleteSpinner}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

function Title({ state, spinnerName }) {
  let title = "Spin the Wheel!";
  if ([States.SpinTheWheel, States.EditSpinner].includes(state)) {
    title = spinnerName;
  } else if (state === States.AddSpinner) {
    title = "New Spinner!";
  }
  return <div className="title">{title}</div>;
}

export default App;
